export default __webpack_public_path__ + "static/media/icons8-tiktok.ea41dcab.svg";